<template>
  <a
    class="d-sticky-menu-save-to-library menu-entry"
    :class="{ 'active': !!storeBookshelf }"
    :disabled="isProcessing"
    @click="saveToLibrary"
  >
    <span
      v-if="isProcessing"
      class="menu-entry-content"
    >
      <DuiLoadingIndicator
        class="space-bottom-1em"
        size="sm"
      />
      <span>Saving...</span>
    </span>

    <span
      v-else
      class="menu-entry-content"
    >
      <DuiIconLibrary class="icon-lg" />

      <span v-if="!storeBookshelf">Save</span>
      <span v-else>Saved</span>
    </span>
  </a>
</template>

<script>
import Vue from 'vue';

import bookshelfService from '@d-services/bookshelf-service/bookshelf-service';
import { getErrorMessage } from '@d-shared/utils/errors';
import { INITIAL_BOOKSHELF } from '@d-shared/config';
import URLS from '@d-shared/urls/urls';
import Window from '@d-shared/utils/window';

export default {
  props: {
    bookshelf: {
      type: String,
      default: null,
    },
    bookUrl: {
      type: String,
      required: true,
    },
    isUserSignedIn: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    isProcessing: false,
  }),
  computed: {
    storeBookshelf() {
      return this.$store.getters['Book/get-bookshelf'];
    },
  },
  mounted() {
    this.setBookshelf();
  },
  methods: {
    async addToLibrary() {
      this.$set(this, 'isProcessing', true);

      try {
        const data = {
          bookshelf_entry: {
            bookshelf: INITIAL_BOOKSHELF,
            book_url: this.bookUrl,
            skip_post: true,
          },
        };

        await bookshelfService.addEntry(data);
        this.$store.dispatch('Book/setBookshelf', INITIAL_BOOKSHELF);
        Vue.duiNotificationManager.success('Book added to your bookshelf.');
      } catch (error) {
        Vue.duiNotificationManager.error(getErrorMessage(error));
      }

      this.$set(this, 'isProcessing', false);
    },

    goToBookshelf() {
      Window.goTo(URLS.app.library.bookshelf);
    },

    saveToLibrary() {
      if (!this.isUserSignedIn) {
        Vue.prototype.signupModal.show();
        return;
      }

      if (this.isProcessing) {
        return;
      }

      if (!this.storeBookshelf) {
        this.addToLibrary();
        return;
      }

      this.goToBookshelf();
    },

    setBookshelf() {
      if (!this.bookshelf) {
        return;
      }

      this.$store.dispatch('Book/setBookshelf', this.bookshelf);
    },
  },
};
</script>

<style lang="scss" scoped>
.d-sticky-menu-save-to-library {
  .menu-entry-content {
    align-items: center;
    display: flex;
    flex-direction: column;
  }
}
</style>
